import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgShuffle = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M17.507 4.006a.75.75 0 0 1 1.058-.07l3.429 3a.75.75 0 0 1 0 1.128l-3.429 3a.75.75 0 1 1-.988-1.128l1.927-1.686h-4.515a.25.25 0 0 0-.197.097l-6.4 8.227a1.75 1.75 0 0 1-1.381.676H3a.75.75 0 0 1 0-1.5h4.01a.25.25 0 0 0 .198-.097l6.4-8.227a1.75 1.75 0 0 1 1.381-.676h4.515l-1.927-1.686a.75.75 0 0 1-.07-1.058M2.25 7.5A.75.75 0 0 1 3 6.75h4.01c.541 0 1.05.25 1.382.676l1.45 1.864a.75.75 0 0 1-1.184.92l-1.45-1.863a.25.25 0 0 0-.197-.097H3a.75.75 0 0 1-.75-.75m15.257 5.506a.75.75 0 0 1 1.058-.07l3.429 3a.75.75 0 0 1 0 1.128l-3.429 3a.75.75 0 1 1-.988-1.128l1.927-1.686h-4.515c-.54 0-1.05-.25-1.381-.676l-1.422-1.828a.75.75 0 0 1 1.184-.92l1.422 1.827a.25.25 0 0 0 .197.097h4.515l-1.927-1.686a.75.75 0 0 1-.07-1.058"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgShuffle;
